import { observer } from "mobx-react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { Column, ColumnProps } from "primereact/column";
import { DataTable } from "primereact/datatable";
import qs from 'qs';
import React, { RefObject } from 'react';
import { Link } from 'react-router-dom';
import { Flex } from "reflexbox";

import { DataSource } from "../../../models/DataSource";
import { DataTableFilterService } from "../../../services/DataTableFilterService";
import { MonitoringRestService } from "../../../services/MonitoringRestService";
import { DependencyContainer } from "../../../utils/DependencyInjection";
import { ProduktivitasSummaryFilterContainer } from "./ProduktivitasSummaryFilterContainer";
import _, { upperCase } from "lodash";
import moment from "moment";
import { IProduktivitasSummaryFilterContainerValue } from "./IProduktivitasSummaryFilterContainerValue";
import { ColumnGroup } from "primereact/columngroup";
import { Row } from "primereact/row";
import { Growl } from "primereact/growl";
import { TrackingSiteEditFormModal } from "../../trackingSite/TrackingSiteEditFormModal";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";
import { IMonitoringPodKepalaKurirDetailCourierContainerQuery } from "../../monitoringPod/MonitoringPodKepalaKurirDetailCourierContainer";
import { IMonitoringPodFilterContainerValueNew } from '../IMonitoringPodFilterContainerValueNew';
import { IMonitoringPodDetailContainerQueryNew } from "../IMonitoringPodDetailContainerQueryNew"
import { toJS } from "mobx";
@observer
export class ProductivitasMetaBaseSummaryContainer extends React.Component<
any,
any
> {
  dataTableFilterService = DependencyContainer.get(DataTableFilterService);
  monitoringRestService = DependencyContainer.get(MonitoringRestService);

  data;
  growl;
  tableExportData;
  formFilters: IProduktivitasSummaryFilterContainerValue;
  formFiltersDetail: IMonitoringPodFilterContainerValueNew;
  dataSource = new DataSource<any>();
  refFilter: RefObject<
    ProduktivitasSummaryFilterContainer
  > = React.createRef();

  constructor(props) {
    super(props);
    this.state = {
      exportExcelLoading: false,
      showExportDialog: false,
      expandedRows: null,
      displayUpdateDialog: false,
      selectedTrackingSiteId: null,
      footerTotal: {},
      userData: '',
      url: '',
      token:'',
      roleProduktivitas:[
        "Ops - Kepala Kurir SDS First Mile",
        "Ops - Kepala Kurir SDS Last Mile",
        "Ops - Kepala Sigesit",
        "Ops - Koordinator Regional",
        "Root Business Process",
        "Root Cost Control",
      ]
    };
  }

  componentDidMount() {
    // this.dataSource.onPageChange.subscribe(() => {
    //   this.populateDataSource();
    // });
    let userData = ''
    if (localStorage.getItem('branchCode')) {
      const branchCode = localStorage.getItem('branchCode')
      this.monitoringRestService
      .get(`embed/2001?branch_code=${branchCode}`)
      .subscribe(
        (response) => {
          this.setState({
            url: response.url,
            token:response.token,
          })
          
        },
        (e) => {
          
          let msg = {
            severity: "error",
            summary: e.response.data['message'],
          };
          this.growl.show(msg);
          this.dataSource.loading = false;
        },
        () => {
          this.dataSource.loading = false;
        }
      );
    }
    this.setState({
      userData,
    })
  }


  render() {
    let totalGood = 0
    let totalBad = 0
    let totalWarning = 0
    if (this.dataSource) {
      this.dataSource.data.map((d, i) => {
        
        if (upperCase(d.justifikasi) === "BAD") {
          totalBad++
        } else if (upperCase(d.justifikasi) === "GOOD") { 
          totalGood++
        } else if (upperCase(d.justifikasi) === "WARNING") { 
          totalWarning++
        }       
       })
    }
    

    return (
      <div>
        <Dialog
          header="Informasi"
          visible={this.state.showExportDialog}
          style={{ width: "40vw" }}
          modal={true}
          onHide={() => this.setState({ showExportDialog: false })}
        >
          Export excel sedang berjalan, mohon jangan tinggalkan halaman ini
        </Dialog>

        <Growl ref={(el) => (this.growl = el)} style={{ marginTop: "75px" }} />

        <Flex className="card w-full">
          <Flex className="w-full" column>
            <h1>Produktivitas</h1>
            <br />
          </Flex>
        </Flex>

        <div className="card monitor-pod-table-container">
          <div className="row">
            <div className="col-md-12">
              <iframe
        src={this.state.url + this.state.token}
        width={"100%"}
        height={750}
        allowTransparency
      />
            </div>
          </div>
        </div>
      </div>
    );
  }
}
